import { useImperativeHandle } from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";

import type { FormRefType } from "@/types/common";

export function useExposeFormValues<T extends FieldValues>(
  ref: React.Ref<FormRefType<T>>,
  form: UseFormReturn<T>
) {
  useImperativeHandle(ref, () => ({
    getValues: () => form.getValues(),
  }));
}
